import { Model } from "services/models/model";
import { QueryParams } from "services/models/odata/queryParams";
import { ServiceBase } from "services/servicebase";
import { Observable } from "rxjs";
import { Filter } from "services/models/odata/filter";
import { OdataEntityField } from "services/models/odata/odataEntityField";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { appInjector } from "@core/injector/app-injector.service";
import { CustomAction } from "services/models/customAction";
export abstract class ListAbstract<M extends Model, S extends ServiceBase<M>> {
  queryParams: QueryParams = new QueryParams();

  filterFields = [];
  exclude = ["id"];
  searchable = true;
  menuActions = true;
  docUrl?: string;
  canCreateExternal = false;
  canEdit = true;
  canDelete = false;
  customActions?: CustomAction[];
  additionalFilterActions?: CustomAction[];
  protected _modalService;
  private _service: S;
  private _list: M[] = [];
  private _count: number;
  protected fields?: OdataEntityField[];
  abstract title: string;
  protected disabledLoading = false;
  
  constructor(service: S) {
    this._service = service;
    this._count = 0;
    this.queryParams.perPage = 10;
    this.queryParams.top = this.queryParams.perPage;
    this._modalService = appInjector.get(NgbModal);
  }

  get serviceAbstract(): S {
    return this._service;
  }

  get fieldParams(): string[] {
    if (this.fields) return this.fields.map((x) => x.field);
    else return [];
  }

  get fieldsAlias(): string[] {
    if (this.fields)
      return this.fields.filter((x) => x.alias).map((x) => x.alias);
    else return [];
  }

  get list(): M[] {
    return this._list;
  }

  set list(model) {
    this._list = model;
  }

  get count(): number {
    return this._count;
  }

  set count(count: number) {
    this._count = count;
  }

  public query(): Observable<any> {
    const obser = new Observable<any>((observer) => {
      this.serviceAbstract.list(this.queryParams, this.disabledLoading).subscribe((res) => {
        this._count = res.count;
        this._list = res.data;
        observer.next(this._list);
      });
    });
    obser.subscribe();
    return obser;
  }

  //caso precise alterar a propriedade _list
  //use esse metodo
  public queryList(): Observable<any> {
    const obser = new Observable<any>((observer) => {
      this.serviceAbstract.list(this.queryParams, this.disabledLoading).subscribe((res) => {
        this._count = res.count;
        this._list = res.data;
        observer.next(this._list);
      });
    });
    return obser;
  }

  maxPage(): number {
    if (this.count > 0) {
      const max = Math.ceil(this.count / this.queryParams.perPage);
      return max;
    }
    return 0;
  }

  changePage(page: any) {
    if (this.queryParams.page !== page) {
      this.queryParams.page = page;
      this.queryParams.top = this.queryParams.perPage;
      this.queryParams.skip = this.queryParams.perPage * (page - 1);
      this.query();
    }
  }

  setOrder(field: string) {
    this.queryParams.orderBy = field;
    this.queryParams.orderByOrder =
      this.queryParams.orderByOrder === "asc" ? "desc" : "asc";
    this.query();
  }

  filterByProperty(event: any, property: string) {
    this.queryParams.filter = Filter.contains(event, property);
    this.query();
    this.queryParams.filter = "";
  }

  changeStatus(id: string) {
    this._service.changeStatus(id).subscribe(() => {
      this.query();
    });
  }
}
